"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Form_1 = __importDefault(require("../../Generic/Form"));
function makeDisabled(specPart, path) {
  specPart.readOnly = true;
  for (var key in specPart) {
    var value = specPart[key];
    path.push(key);
    if (typeof value === 'object') {
      makeDisabled(value, path);
    }
    path.splice(-1, 1);
  }
}
function ProductExtraConfig(props) {
  var product = props.product,
    disabled = props.disabled,
    values = props.values,
    setValues = props.setValues;
  var _a = react_1.default.useState(null),
    formSpec = _a[0],
    setFormSpec = _a[1];
  react_1.default.useEffect(function () {
    try {
      if (product.extra_config_schema) {
        var spec = JSON.parse(product.extra_config_schema);
        if (spec === null || spec === void 0 ? void 0 : spec.schema) {
          if (disabled) {
            makeDisabled(spec === null || spec === void 0 ? void 0 : spec.schema, ['schema']);
          }
          setFormSpec(spec);
        }
      }
    } catch (ex) {
      // bypass
    }
  }, [product, disabled]);
  if (!formSpec) {
    return null;
  }
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(Form_1.default, __assign({}, formSpec, {
    instance: values,
    onChange: function (nextValues) {
      setValues(__assign({}, nextValues));
    },
    renderCustomSubmitButton: function () {
      return null;
    }
  })));
}
exports.default = ProductExtraConfig;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;